import { render } from "./TestManage.vue?vue&type=template&id=1b998cda"
import script from "./TestManage.vue?vue&type=script&lang=js"
export * from "./TestManage.vue?vue&type=script&lang=js"

import "./TestManage.vue?vue&type=style&index=0&id=1b998cda&lang=less"

import exportComponent from "F:\\work\\git\\yunchi\\yc-vue-source\\cloud_share_lib\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__